import template from './included-options.jade';
import { possibleItems, operationalCostsOptions } from '../../../enums/included-options';
import { selectIsArchived, selectIsPublishedOffer } from '../../../../../../shared/selectors/offer';

export default angular
  .module('cian.addForm.priceIncludedOptions', [])
  .directive('cianAfPriceAndDealTermsIncludedOptions', () => ({
    scope: {},
    bindToController: {
      ad: '=',
    },
    controller($scope, store, deviceService) {
      'ngInject';

      const state = store.getState();
      const isPublished = selectIsPublishedOffer(state);
      const isFromArchive = selectIsArchived(state);

      this.ad.bargainTerms.includedOptions = this.ad.bargainTerms.includedOptions || [];
      $scope.items = possibleItems.map(item => ({
        ...item,
        checked: this.ad.bargainTerms.includedOptions.includes(item.value) || (!isPublished && !isFromArchive),
      }));
      $scope.operationalCostsOptions = operationalCostsOptions;
      $scope.isMobile = deviceService.isMobile;

      $scope.$watch(
        () => $scope.items,
        newItems => {
          if (!newItems) {
            return;
          }
          this.ad.bargainTerms.includedOptions = newItems.reduce((acc, item) => {
            if (item.checked) {
              acc.push(item.value);
            }

            return acc;
          }, []);
        },
        true,
      );
    },
    controllerAs: 'includedOptions',
    template,
  })).name;
